module.exports = __webpack_public_path__ + "img/footerlogo_white.png";